module.exports = __webpack_public_path__ + "static/media/sort-size-down.a0996996.svg";